import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _assignRoleRequest = {};
var _assignRoleResponse = {};
var _getRolesRequest = {};
var _getRolesResponse = {};
var _queryRolesRequest = {};
var _queryRolesResponse = {};
var _unassignRoleRequest = {};
var _unassignRoleResponse = {};
function resolveComWixpressMembersMemberrolesMemberRolesUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/members/v1/roles',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'members.wixapps.net': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function assignRole(payload) {
    var _a = serializer(_assignRoleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignRoleResponse, {}).fromJSON;
    function __assignRole(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.role',
            method: 'POST',
            methodFqn: 'com.wixpress.members.memberroles.MemberRoles.AssignRole',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberrolesMemberRolesUrl({
                protoPath: '/v1/roles/members/{memberId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignRole.fromReq = fromReq;
    __assignRole.__isAmbassador = true;
    return __assignRole;
}
export function unassignRole(payload) {
    var _a = serializer(_unassignRoleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unassignRoleResponse, {}).fromJSON;
    function __unassignRole(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.role',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.memberroles.MemberRoles.UnassignRole',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberrolesMemberRolesUrl({
                protoPath: '/v1/roles/members/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unassignRole.fromReq = fromReq;
    __unassignRole.__isAmbassador = true;
    return __unassignRole;
}
export function getRoles(payload) {
    var _a = serializer(_getRolesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRolesResponse, {}).fromJSON;
    function __getRoles(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.role',
            method: 'GET',
            methodFqn: 'com.wixpress.members.memberroles.MemberRoles.GetRoles',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberrolesMemberRolesUrl({
                protoPath: '/v1/roles/members/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRoles.fromReq = fromReq;
    __getRoles.__isAmbassador = true;
    return __getRoles;
}
export function queryRoles(payload) {
    var _a = serializer(_queryRolesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryRolesResponse, {}).fromJSON;
    function __queryRoles(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.role',
            method: 'POST',
            methodFqn: 'com.wixpress.members.memberroles.MemberRoles.QueryRoles',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberrolesMemberRolesUrl({
                protoPath: '/v1/roles/members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryRoles.fromReq = fromReq;
    __queryRoles.__isAmbassador = true;
    return __queryRoles;
}
//# sourceMappingURL=http.impl.js.map